import { appendIf } from '@btime/helpers'
import { gql, useMutation } from '@apollo/client'
import i18n from 'i18next'

import { accountsClient } from '../../../../utils/apollo/api'
import { cleanRequest } from './cleanRequest'
import { useCloseModal, useModalData } from '../../../../components/modals/ModalsContext'

const UPSERT_MUTATION = gql`
  mutation UpsertProject($input: ProjectInput) {
    upsertProject(input: $input) {
      id
    }
  }
`

const CLONE_MUTATION = gql`
  mutation CloneProject($input: ProjectCloneInput, $fromTemplates: Boolean) {
    cloneProject(input: $input, fromTemplates: $fromTemplates) {
      id
    }
  }
`

const validate = (form, setErrors) => {
  const t = i18n.getFixedT(null, 'validations')
  const errors = [
    ...appendIf(!form.name, { path: ['name'], message: t('required') }),
    ...appendIf(!form.icon, { path: ['icon'], message: t('required') }),
    ...appendIf(!form.color, { path: ['color'], message: t('required') })
  ]

  setErrors(errors)
  return errors.length === 0
}

export const useSaveProject = () => {
  const { clone, fromTemplates } = useModalData()
  const mutationQuery = clone ? CLONE_MUTATION : UPSERT_MUTATION
  const [request, state] = useMutation(mutationQuery, {
    refetchQueries: ['Project', 'Projects'],
    client: accountsClient
  })
  const closeModal = useCloseModal()

  const handleRequest = (form, actions) => {
    const { setErrors } = actions
    const isValid = validate(form, setErrors)
    const input = cleanRequest(form, clone)

    if (isValid) {
      return request({ variables: { input, ...(clone ? { fromTemplates } : {}) } }).then(resp => {
        if (!resp.errors) {
          closeModal()
        }
      })
    }
  }

  return [handleRequest, state]
}
